import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-user-notify',
  templateUrl: './user-notify.component.html',
  styleUrls: ['./user-notify.component.scss']
})
export class UserNotifyComponent implements OnInit {

  message: string;

  constructor(private dialogRef: MatDialogRef<UserNotifyComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any) { }

  ngOnInit(): void {
    this.message = this.data.message;
  }

  onClose(){
    this.dialogRef.close(false);
  }

}
